export const generateMeetingUrl = () => {

    return `https://meet.google.com/new`;
  };